import React from "react";
import { Element } from "@craftjs/core";
import { Box } from "components/ui";
import Container from "components/general/Container";
import { useIsMobile } from "utils/hooks/useIsMobile";

const getEmbedUrl = (url: string): string => {
	try {
		const urlObj = new URL(url);
		if (urlObj.hostname.includes("youtube.com") && urlObj.pathname === "/watch") {
			const videoId = urlObj.searchParams.get("v");
			if (videoId) {
				return `https://www.youtube.com/embed/${videoId}`;
			}
		} else if (urlObj.hostname.includes("youtu.be")) {
			const videoId = urlObj.pathname.substring(1); // Remove leading '/'
			if (videoId) {
				return `https://www.youtube.com/embed/${videoId}`;
			}
		}
		// Assume it's already an embed URL or a different valid source
		return url;
	} catch (e) {
		console.error("Invalid URL provided to PageVideo:", url, e);
		// Return a default or empty string if URL parsing fails
		return "https://www.youtube.com/embed/Wq7S2yGwnB4"; // Or return ""
	}
};

export const PageVideo = (props: any) => {
	const { videoUrl } = props;
	const isMobile = useIsMobile();
	const embedUrl = getEmbedUrl(videoUrl);
	const variant = props.videoVariant || "contained";
	if (variant === "contained") {
		return (
			<Container sx={{ alignItems: "center", paddingHorizontal: isMobile ? 24 : "auto" }}>
				<Box
					style={{
						width: "100%",
						maxWidth: 1200,
						alignSelf: "center",
						paddingVertical: 24,
					}}
				>
					<Box
						style={{
							position: "relative",
							width: "100%",
							paddingTop: "56.25%", // 16 : 9
						}}
					>
						<iframe
							src={embedUrl}
							title="Embedded Video"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
								border: 0,
								borderRadius: 16,
							}}
						/>
					</Box>
				</Box>
			</Container>
		);
	}
	return (
		<Box paddingHorizontal={24}>
			<iframe
				src={embedUrl}
				title="Embedded Video"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					border: 0,
					// borderRadius: 16,
				}}
			/>
		</Box>
	);
};

(PageVideo as any).craft = {
	props: {
		videoUrl: "https://www.youtube.com/embed/Wq7S2yGwnB4",
	},
	related: {
		settings: () => <Box>Video Settings</Box>,
	},
};
